import { apiFactory, buildApi } from '@app/client';
import config from '@app/config';
import { initializeUser } from '@app/store/actions/user';
import { setIsAuthenticated, useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';
import { initializeWalletsAsync } from '@app/store/zustand/wallet/initializeWalletsAsync';

import { tokenRefresh } from './actions/token';
import { handleMessage } from './actions/websockets';
import { deferredReduxStore, type DeferredStore } from './deferred-redux-store';

export async function initReduxStore(): Promise<DeferredStore | null> {
    const store = deferredReduxStore();

    buildApi({
        dispatch: store.dispatch,
        wsHandler: handleMessage,
        url: config.apiUrl,
        wsUrl: config.wsUrl,
        wsMaxBackOff: config.wsMaxBackOff,
        websocketConnections: {
            api: {
                handler: handleMessage,
                maxBackOff: config.wsMaxBackOff,
                url: config.websocketConnections.api.url,
            },
            yacs: {
                handler: handleMessage,
                maxBackOff: config.wsMaxBackOff,
                pathname: config.websocketConnections.yacs.pathname,
                url: config.websocketConnections.yacs.url,
            },
        },
    });

    setIsAuthenticated();
    const authenticated = useAuthTokens.getState().isAuthenticated;

    if (authenticated) {
        await store.dispatch(initializeUser());
        await initializeWalletsAsync();
    }

    if (!authenticated) {
        await store.dispatch(tokenRefresh());
        await apiFactory().initializeWebsocket(true);
    }

    return store;
}
